export default __webpack_public_path__ + "static/media/image4.eb3b07cf.jpg";